import { FC, useState } from 'react';
import Select, { components } from 'react-select';
import { selectStyle } from './styles';

interface IReactSelectProps {
  isLoading: boolean;
  allOptions: any;
  setSelectedOption: any;
  placeholder: string;
  value?: any;
  [key: string]: any;
}

const InputOption = ({
  getStyles,
  Icon,
  isDisabled,
  isFocused,
  isSelected,
  children,
  innerProps,
  ...rest
}: any) => {
  const [isActive, setIsActive] = useState(false);
  const onMouseDown = () => setIsActive(true);
  const onMouseUp = () => setIsActive(false);
  const onMouseLeave = () => setIsActive(false);

  // styles
  let bg = 'transparent';
  if (isFocused) bg = '#eee';
  if (isActive) bg = '#B2D4FF';

  const style = {
    alignItems: 'center',
    backgroundColor: bg,
    color: 'inherit',
    display: 'flex ',
  };

  // prop assignment
  const props = {
    ...innerProps,
    onMouseDown,
    onMouseUp,
    onMouseLeave,
    style,
  };

  return (
    <components.Option
      {...rest}
      isDisabled={isDisabled}
      isFocused={isFocused}
      isSelected={isSelected}
      getStyles={getStyles}
      innerProps={props}
    >
      {children}
    </components.Option>
  );
};

const ReactSelect: FC<IReactSelectProps> = ({
  isLoading,
  allOptions,
  setSelectedOption,
  placeholder,
  value,
  ...rest
}) => {
  return (
    <Select
      isLoading={isLoading}
      isRtl={false}
      isSearchable
      options={allOptions}
      onChange={(option: any) => setSelectedOption(option)}
      styles={selectStyle}
      value={value}
      components={{
        Option: InputOption,
      }}
      placeholder={placeholder}
      {...rest}
    />
  );
};

export default ReactSelect;
